import { EMAIL_ADDRESS } from '@/constants';
import { generateStyle } from '@/utils';
import i18next from 'i18next';
import styles from './ContactEmail.module.css';

const defaultEmail = EMAIL_ADDRESS.seel;
export const SeelEmail = ({
  email = defaultEmail, text, className, customStyleConfig,
}) => {
  const displayText = text || email;
  return (
    <a href={`mailto:${email}`}>
      <span className={`${styles.emailText} ${className}`} style={generateStyle(customStyleConfig?.display)}>{displayText}</span>
    </a>
  );
};

export const ContactEmail = ({
  frontMessage = i18next.t('Need help? Contact us at'), email = defaultEmail, text, customStyleConfig,
}) => (
  <div className={styles.contactEmailContainer}>
    <span style={{
      ...generateStyle(customStyleConfig?.display),
    }}
    >
      {frontMessage}
    </span>
    <SeelEmail email={email} text={text || email} customStyleConfig={customStyleConfig} />
  </div>
);
